import ExcelJS from "exceljs";

const thinBorder = {
  top: { style: "thin", color: { argb: "FFCCCCCC" } },
  left: { style: "thin", color: { argb: "FFCCCCCC" } },
  bottom: { style: "thin", color: { argb: "FFCCCCCC" } },
  right: { style: "thin", color: { argb: "FFCCCCCC" } },
};

/**
 * Xuất bảng danh sách HRM: 1 dòng tiêu đề (merge), 1 dòng header in đậm, viền, đóng băng 2 dòng đầu.
 * @param {any[][]} aoa — hàng 0 = header
 * @param {{ title: string, sheetName?: string, filename: string, columnWidths?: number[] }} opts
 */
export async function downloadHrmListingExcel(aoa, opts) {
  const { title, sheetName = "Sheet1", filename, columnWidths } = opts;
  if (!aoa?.length) return;

  const numCols = aoa[0].length;
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet(sheetName.slice(0, 31), {
    views: [{ state: "frozen", ySplit: 2 }],
  });

  ws.mergeCells(1, 1, 1, numCols);
  const titleCell = ws.getCell(1, 1);
  titleCell.value = title;
  titleCell.font = { bold: true, size: 14 };
  titleCell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
  ws.getRow(1).height = 30;

  const headerRow = ws.getRow(2);
  aoa[0].forEach((val, idx) => {
    const c = headerRow.getCell(idx + 1);
    c.value = val;
    c.font = { bold: true, size: 11 };
    c.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    c.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFF3F4F6" },
    };
    c.border = thinBorder;
  });
  headerRow.height = 24;

  for (let r = 1; r < aoa.length; r += 1) {
    const row = ws.getRow(r + 2);
    row.height = 20;
    aoa[r].forEach((val, colIndex) => {
      const c = row.getCell(colIndex + 1);
      c.value = val;
      c.border = thinBorder;
      if (colIndex === 0) {
        c.alignment = { horizontal: "center", vertical: "middle" };
      } else if (colIndex >= 1 && colIndex <= 3) {
        c.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
      } else if (colIndex === numCols - 1) {
        c.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
      } else {
        c.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
      }
    });
  }

  const defaultW = (i) => {
    if (i === 0) return 6;
    if (i <= 3) return 22;
    return 14;
  };
  for (let i = 1; i <= numCols; i += 1) {
    const w = columnWidths?.[i - 1] ?? defaultW(i - 1);
    ws.getColumn(i).width = w;
  }

  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
